export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAABHAQMAAAD1MR/BAAAAA1BMVEX///+nxBvIAAAAC0lEQVQIHWMYVAAAAI4AAYU8iRgAAAAASUVORK5CYII="